import { render, staticRenderFns } from "./ViewInvoice.vue?vue&type=template&id=4ed66f11&scoped=true"
import script from "./ViewInvoice.vue?vue&type=script&lang=js"
export * from "./ViewInvoice.vue?vue&type=script&lang=js"
import style0 from "./ViewInvoice.vue?vue&type=style&index=0&id=4ed66f11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed66f11",
  null
  
)

export default component.exports